import { isValidDate } from '@cian/utils';

/**
 * Приводит дату к формату YYYY-MM-DD
 */
export const formatDateToYYYYMMDD = (date: Date) => (isValidDate(date) ? date.toISOString().slice(0, 10) : '');
